import React, { FC, useState } from 'react';
import cn from 'classnames';

import styles from './FilterButton.module.scss';

interface Props {
    hideFiltersCallback: () => void;
    hideFilters: boolean;
}

const FilterButton: FC<Props> = ({ hideFiltersCallback, hideFilters }) => {

    return (
        <button className={
            cn(styles.bns3_filter_button, hideFilters ? styles.bns3_filter_button__open : styles.bns3_filter_button__close)}
            type="button"
            data-testid="test-id-filter-button"
            onClick={hideFiltersCallback}>
            <span>Filters</span>
        </button>
    )
};

export default FilterButton;